import { defineMessages } from 'react-intl';

export default defineMessages({
    AddtoQuote: {
        defaultMessage: 'Add Vehicle to Quote',
        id: 'quoteandbind.ea.views.ea-vehicle-details.Add Vehicle to Quote:'
    }
});
